import { CheckIcon } from "@heroicons/react/solid";
import { classNames } from "../../utils/classNames";
import { Button } from "../button";

type PricingPlanFeature = {
  text: string;
  comingSoon?: boolean;
};

export type PricingPlanProps = {
  name: string;
  priceMonthly: string;
  features: PricingPlanFeature[];
  available: boolean;
};

type PricingPlanCardProps = PricingPlanProps & {
  isSelected?: boolean;
  onClick?: () => void;
};

export const PricingPlanCard = ({
  name,
  available,
  priceMonthly,
  features,
  isSelected,
  onClick,
}: PricingPlanCardProps) => (
  <div
    key={name}
    className={classNames(
      "flex flex-col rounded-lg shadow-md overflow-hidden transition duration-300",
      // available && "lg:transform hover:scale-105",
      isSelected && "ring-primary-400 ring-2"
    )}
  >
    <div className="p-6 bg-white sm:p-8 sm:pb-4 relative">
      <div
        className={`absolute right-4 top-4 flex items-center justify-center h-8 w-8 rounded-full bg-primary-100`}
      >
        {isSelected && (
          <CheckIcon className="h-6 w-6 text-primary-600" aria-hidden="true" />
        )}
      </div>
      <div>
        <h3
          className="inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wide uppercase bg-primary-100 text-primary-600"
          id="tier-standard"
        >
          {name}
        </h3>
      </div>
      <div className="mt-4 flex items-baseline text-5xl font-extrabold">
        ${priceMonthly}
        <span className="ml-1 text-xl font-medium text-gray-500">/mo</span>
      </div>
      <p className="mt-2 text-md text-gray-500">Per team member</p>
    </div>
    <div className="flex-1 flex flex-col justify-between px-6 pt-6 pb-8 bg-gray-50 space-y-6 sm:p-10 sm:pt-6">
      <ul role="list" className="space-y-4">
        {features.map(({ text, comingSoon }) => (
          <li key={text} className="flex items-start">
            <div className="flex-shrink-0">
              <CheckIcon
                className="h-6 w-6 text-green-500"
                aria-hidden="true"
              />
            </div>
            <p className="ml-3 text-sm text-gray-700">{text}</p>
            {comingSoon && (
              <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-800">
                Coming Soon
              </span>
            )}
          </li>
        ))}
      </ul>
      {available ? (
        <Button
          text={isSelected ? "Selected" : "Select"}
          size="xl"
          color="dark"
          onClick={onClick}
        />
      ) : (
        <Button text="Coming Soon" size="xl" color="dark" enabled={false} />
      )}
    </div>
  </div>
);
